import React from "react";

/**
 * @component BudgetAlertIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <BudgetAlertIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const BudgetAlertIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="BudgetAlertIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M14 17v1h-4v-1h4zM13 5l.001 1.1A5.002 5.002 0 0117 11v5H7v-5a5.002 5.002 0 014-4.9V5h2zm-1 2a4 4 0 00-3.995 3.8L8 11v4h8v-4a4 4 0 00-3.8-3.995L12 7z"
        fillRule="nonzero"
      />
    </svg>
  )
);
BudgetAlertIcon.displayName = "BudgetAlertIcon";
export default BudgetAlertIcon;
